import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "base",
  "use": "base-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"base\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.9361 4.10352L15.7072 8.00012L12.9361 11.8967L11.7137 11.0274L13.3332 8.75012H2.66597L4.28546 11.0274L3.06305 11.8967L0.291992 8.00012L3.06305 4.10352L4.28546 4.97283L2.66597 7.25012H13.3332L11.7137 4.97283L12.9361 4.10352Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol